import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Home from './MyComponents/Home';
import About from './MyComponents/About';
import Navbar from './MyComponents/Navbar';
import Service from './MyComponents/Service';
import Contactus from './MyComponents/Contactus';
import Footer from './MyComponents/Footer';
import GotoTop from './MyComponents/GotoTop';

function App() {
  return (
    <>
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/contact" component={Contactus} />
        <Route exact path="/service" component={Service} />
        <Redirect to="/" />
      </Switch>
      <GotoTop />
      <Footer />
    </>
  );
}

export default App;
